export const JobCvCriteriaEnglish = {
  title: 'AI CV scoring criteria',
  description: 'Add criteria to score candidate CVs and identify the best match candidates for the role.',
  addCriteria: 'Add criterion',
  regenerateUsingAI: 'Re-generate using AI',
  generateUsingAI: 'Generate using AI',
  howMatchingCalculated: 'How candidate matching is calculated?',
  bestMatchTitle: '70-100: Best match:',
  bestMatchDescription: 'The candidate meets all the major criteria and is highly suitable for the role.',
  goodMatchTitle: '40-69: Good match:',
  goodMatchDescription: 'The candidate meets many important criteria and is a strong contender.',
  weakMatchTitle: '0-39: Weak match:',
  weakMatchDescription: 'The candidate does not meet several critical criteria.',
  cancel: 'Cancel',
  save: 'Save',
  validationMessage: 'Please add at least one criteria',
  criteria: 'Criteria',
  criterion: 'Criterion',
  titleLabel: 'Title*',
  titlePlaceholder: 'Enter criterion title (max 255 characters)',
  titleRequired: 'Title is required',
  descriptionLabel: 'Description*',
  descriptionPlaceholder: 'Enter criterion description (max 1024 characters)',
  descriptionRequired: 'Description is required',
  descriptionMaxLength: 'Description cannot exceed 1024 characters',
  weightLabel: 'Weight*',
  weightPlaceholder: 'Enter criterion weight',
  weightRequired: 'Weight is required',
  weightRange: 'Weight must be between 1 and 100',
  aiGeneratedCriteriaSuccess: 'Criteria successfully generated!',
  criteriaSaved: 'Criteria saved successfully.',
  sumOfWeightsMessage: 'Please make sure the sum of all weights equals to 100'
}

export const JobCvCriteriaArabic = {
  title: 'معايير تقييم السيرة الذاتية بالذكاء الاصطناعي',
  description: 'أضف معايير لتقييم السير الذاتية وتحديد أفضل المرشحين للوظيفة.',
  addCriteria: 'إضافة معيار',
  regenerateUsingAI: 'إعادة توليد باستخدام الذكاء الاصطناعي',
  generateUsingAI: 'توليد باستخدام الذكاء الاصطناعي',
  howMatchingCalculated: 'كيف يتم حساب مطابقة المرشح؟',
  bestMatchTitle: '70-100: مطابقة ممتازة:',
  bestMatchDescription: 'المرشح يفي بجميع المعايير الرئيسية وهو مناسب للغاية للوظيفة',
  goodMatchTitle: '40-69: مطابقة جيدة:',
  goodMatchDescription: 'المرشح يفي بالعديد من المعايير الهامة وهو مرشح قوي.',
  weakMatchTitle: '0-39: مطابقة ضعيفة:',
  weakMatchDescription: 'المرشح لا يفي بعدة معايير حاسمة.',
  cancel: 'إلغاء',
  save: 'حفظ',
  validationMessage: 'يرجى إضافة معيار واحد على الأقل',
  criteria: 'معيار',
  criterion: 'معيار',
  titleLabel: 'العنوان*',
  titlePlaceholder: 'أدخل عنوان المعيار (بحد أقصى 255 حرفًا)',
  titleRequired: 'العنوان مطلوب',
  descriptionLabel: 'الوصف*',
  descriptionPlaceholder: 'أدخل وصف المعيار (بحد أقصى 1024 حرفًا)',
  descriptionRequired: 'الوصف مطلوب',
  descriptionMaxLength: 'لا يمكن أن يتجاوز الوصف 1024 حرفًا',
  weightLabel: 'الوزن*',
  weightPlaceholder: 'أدخل وزن المعيار',
  weightRequired: 'الوزن مطلوب',
  weightRange: 'يجب أن يكون الوزن بين 1 و 100',
  aiGeneratedCriteriaSuccess: 'تم إنشاء المعايير بنجاح!',
  criteriaSaved: 'تم حفظ المعايير بنجاح.',
  sumOfWeightsMessage: 'يرجى التأكد من أن مجموع جميع الأوزان يساوي 100'
}
